export default {"src":"/_next/static/media/mobile-hero.026e4162.svg","height":554,"width":613};